<template>
  <div
    :class="
      `c-button c-button-${type} ${styles} fb fb-main-center fb-cross-center ${
        disabled ? 'button-disabled' : ''
      }`
    "
    @click="handlerClick"
  >
    <span>
      <slot></slot>
    </span>
  </div>
</template>

<script>
export default {
  name: 'commonButton',
  /* eslint-disable */
  components: {},
  props: {
    styles: {
      type: String,
      default: 'font-34 h-44'
    },
    type: {
      // 时间格式转换类型指定
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      date: ''
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {},
    handlerClick(e) {
      this.$emit('click', e)
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.c-button {
  width: 100%;
  border-radius: 8px;
  cursor: pointer;
  &.c-button-primary {
    background: #006afe;
    color: #ffffff;
  }
  &.c-button-primary-empty {
    border: 1px solid rgba(#006afe, 1);
    color: #006afe;
  }
  &.c-button-info {
    background: #ffffff;
    color: rgba(#191f25, 0.56);
    border: 1px solid rgba(#191f25, 0.12);
  }
  &.c-button-delete {
    background: #ffffff;
    color: #fb602d;
    border: 1px solid rgba(251, 96, 45, 0.12);
  }
  &.c-button-add {
    color: #171a1d;
    background: #f2f4f5;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }
  &.c-button-danger {
    background: #f25643;
    color: #ffffff;
    // border: 1px solid #f25643;
  }
  &.c-button-cancel {
    background: rgba(25, 31, 37, 0.08);
    color: #ffffff;
    // border: 1px solid #f25643;
  }
  &.c-button-preview {
    background: rgba(25, 31, 37, 0.08);
    color: #171a1d;
  }
  &.c-button-gray {
    background: rgba(242, 244, 245, 1);
    color: #171a1d;
    border: 1px solid rgba(17, 31, 44, 0.08);
  }
  &.c-button-end {
    background: #fb602d;
    color: #ffffff;
  }
  &.c-button-device {
    background: #ffffff;
    color: #ff5219;
  }
  &.c-button-device-disabled {
    background: #ffffff;
    color: rgba(23, 26, 29, 0.24);
  }
  &.button-disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}
</style>
